import { environment } from '../../lib/environment';
import { currentTimeZoneStore, } from '../../lib/helpers/date/currentTimeZone';
import { logger } from '../../lib/helpers/misc/logger';
import { HttpPromiseState } from '../../lib/helpers/promise/HttpPromiseState';
import {
    CurrentUserResponse,
    LoginSuccessResponse,
    LogoutSuccessResponse,
    SignInModel,
    SignInWithTokenModel
} from '../models/user';
import { UserStatus } from '../models/user-status';
import { httpClient } from '../utils/httpClient';
import { userStatusBuilder } from '../utils/userStatusBuilder';

class AuthenticationLoaders {
    async whoAmI(): Promise<UserStatus> {
        let url = `${environment.apiServer}/user/current-user`;
        try {
            let response = await httpClient.axios.get<CurrentUserResponse | null>(url);
            let data = response.data;
            if (data === null) return userStatusBuilder.loggedOut();
            currentTimeZoneStore.update(data);
            return userStatusBuilder.loggedIn(data.User);
        } catch (e) {
            logger.error('AuthenticationLoadersClass', e);
            return userStatusBuilder.serverUnreachable();
        }
    }

    signIn(request: SignInModel): HttpPromiseState<LoginSuccessResponse> {
        let url = `${environment.apiServer}/user/sign-in`;
        return httpClient.state.post<LoginSuccessResponse>(url, request);
    }

    signInWithToken(request: SignInWithTokenModel): HttpPromiseState<LoginSuccessResponse> {
        let url = `${environment.apiServer}/user/sign-in/token`;
        return httpClient.state.post<LoginSuccessResponse>(url, request);
    }

    signOut(): void {
        let url = `${environment.apiServer}/user/sign-out`;
        httpClient.axios.post<LogoutSuccessResponse>(url, null);
        document.cookie = 'AuthNonce=; path=/';
    }

    async changeLang(lang: string) {
        let url = `${environment.apiServer}/user/change-lang`;
        const request = {
            lang,
        };
        return await httpClient.axios.post(url, request);
    }
}

export const authenticationLoaders = new AuthenticationLoaders();
